import CarInfiniteScrollContainer from "../../../components/car/other/CarInfiniteScroll";

const CarInfiniteScroll = () => {
  return <CarInfiniteScrollContainer />;
};

export default CarInfiniteScroll;
